import React, { useEffect } from 'react';
import { Col, Divider, Row, Typography, Card } from 'antd';
import { CalendarOutlined, NotificationOutlined } from '@ant-design/icons';

/* Components */
import CallsTableNih from '../CallsTableNih';
import CallsTablePfizer from '../CallsTablePfizer';
import CallsTableUkri from '../CallsTableUkri';


/* logotypes */
import logo_sds_color from '../../media/logo_sds_color.svg';
import grants_logo from '../../media/grants-logo.png';
import pfizer from '../../media/pfizer.png';
import ukri from '../../media/UKRI.png';

const { Title, Paragraph, 
          // Link 
      } = Typography;

const Convocatorias2025 = ({ core }) => {
  useEffect(() => {
    document.title = 'Convocatorias 2025 | SALUDATA';
  }, []);

const convocatorias = [ //para definir las convocatorias nacionales
    // {
    //   titulo: 'Convocatoria de Proyectos de Investigación en Salud Pública 2025',
    //   descripcion: 'Financia propuestas enfocadas en la mejora de la salud comunitaria, vigilancia epidemiológica y determinantes sociales de la salud. Dirigida a instituciones académicas, ONGs y grupos de investigación.',
    //   fechaLimite: '30 de abril de 2025',
    //   enlace: 'https://saludata.gov.co/convocatorias/investigacion-salud-2025'
    // },
    // {
    //   titulo: 'Becas para Jóvenes Investigadores en Salud Digital',
    //   descripcion: 'Apoyo económico para estudiantes y recién graduados que desarrollen soluciones tecnológicas innovadoras en el ámbito de la salud digital, como apps móviles, telemedicina y análisis de datos.',
    //   fechaLimite: '15 de mayo de 2025',
    //   enlace: 'https://saludata.gov.co/convocatorias/becas-salud-digital-2025'
    // },
    // {
    //   titulo: 'Convocatoria de Cofinanciación para Proyectos de Atención Primaria en Zonas Rurales',
    //   descripcion: 'Cofinanciación de proyectos que fortalezcan la atención primaria en salud en municipios rurales del país, incluyendo formación del talento humano, dotación básica y acceso a servicios.',
    //   fechaLimite: '10 de junio de 2025',
    //   enlace: 'https://saludata.gov.co/convocatorias/atencion-primaria-rural-2025'
    // }
  ];

  return (
    <Row justify="center" style={{ marginTop: '50px' }}>
      <Col xxl={20} md={24}>
        <Title className="bold" level={1}>
          Convocatorias 2025
        </Title>
        <Title level={5} style={{ color: '#515152' }}>
          Aquí encontrará las convocatorias locales, nacionales e internacionales vigentes que financian o apoyan proyectos de investigación en salud vigentes.
        </Title>
        <Divider />
          <Divider />
        <Title className="bold" level={3}>
          Secretaría Distrital de Salud
        </Title>
        <img
          className="calls__logo-container"
          src={logo_sds_color}
          alt="Logotipo Secretaría de Salud de Bogotá">
        </img>
        <Paragraph level={5} style={{ color: '#515152' }}>
          No hay disponibles en el momento.
        </Paragraph>
          <Divider />
        <Row gutter={[24, 24]}>
          {convocatorias.map((conv, index) => (
            <Col xs={24} sm={24} md={12} lg={8} key={index}>
              <Card
                hoverable
                style={{
                  borderRadius: 16,
                  boxShadow: '0 6px 24px 0 rgba(24, 144, 255, 0.10), 0 1.5px 6px 0 rgba(0,0,0,0.04)',
                  background: 'linear-gradient(135deg, #e0f7fa 0%, #fff 100%)',
                  minHeight: 320,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
                bodyStyle={{ padding: 24 }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <NotificationOutlined style={{ fontSize: 28, color: '#1890ff' }} />
                    <span style={{
                      fontWeight: 600,
                      fontSize: 18,
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      lineHeight: 1.2,
                      flex: 1
                    }}>
                      {conv.titulo}
                    </span>
                  </div>
                }
              >
                <Paragraph style={{ fontSize: 16, marginBottom: 16 }}>
                  {conv.descripcion}
                </Paragraph>
                <Paragraph style={{ fontSize: 15, color: '#1890ff', marginBottom: 16 }}>
                  <CalendarOutlined /> <b>Fecha límite:</b> {conv.fechaLimite}
                </Paragraph>
                <a
                  href={conv.enlace}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    background: '#1890ff',
                    color: '#fff',
                    padding: '8px 20px',
                    borderRadius: 6,
                    fontWeight: 500,
                    textDecoration: 'none',
                    transition: 'background 0.2s',
                    boxShadow: '0 2px 8px rgba(24,144,255,0.10)'
                  }}
                  onMouseOver={e => (e.currentTarget.style.background = '#40a9ff')}
                  onMouseOut={e => (e.currentTarget.style.background = '#1890ff')}
                >
                  Más información
                </a>
              </Card>
            </Col>
          ))}
        </Row>
        <Divider />
          <Title className="bold" level={3}>
            NIH Grants & Funding
          </Title>
          <img
            className="calls__logo-container"
            src={grants_logo}
            alt="Logotipo Grants & Funding"
          />
          <CallsTableNih />
        <Divider />
          {/* 🔹 Pfizer con link externo */}
          <Title className="bold" level={3}>Pfizer</Title>
          <img className="calls__logo-container" src={pfizer} alt="Logotipo Pfizer" />
          <Paragraph style={{ marginTop: 16 }}>

          </Paragraph>
          <a
            href="https://www.pfizer.com/about/programs-policies/grants/competitive-grants"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              marginTop: 8,
              background: '#1890ff',
              color: '#fff',
              padding: '8px 20px',
              borderRadius: 6,
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'background 0.2s',
              boxShadow: '0 2px 8px rgba(24,144,255,0.10)'
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = '#40a9ff')}
            onMouseOut={(e) => (e.currentTarget.style.background = '#1890ff')}
          >
            Para más información, haga clic aquí
          </a>
          <Divider />
          <CallsTablePfizer />
          <Divider />
          <Title className="bold" level={3}>
            UK Research and Innovation - UKRI
          </Title>
          <img
            className="calls__logo-container"
            src={ukri}
            alt="Logotipo UK Research and Innovation"
          />
          <CallsTableUkri />

      </Col>
    </Row>
  );
};

export default Convocatorias2025;
